import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var SelectorsBlock = styled.div.withConfig({
  displayName: "Selectors__SelectorsBlock",
  componentId: "sc-1s3aunk-0"
})(["display:flex;position:relative;z-index:21;margin-top:18px;", ";"], maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var horizontalStyles = css(["margin:0 auto;"]);
var verticalStyles = css(["position:absolute;left:0;transform:rotate(270deg) translate(260px,-110px);"]);
export var SelectorBlock = styled.div.withConfig({
  displayName: "Selectors__SelectorBlock",
  componentId: "sc-1s3aunk-1"
})(["display:inline;margin-bottom:18px;margin-right:16px;", " &:nth-child(1){min-width:240px;}&:nth-child(3){min-width:130px;margin-left:auto;}"], function (_ref) {
  var _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === void 0 ? false : _ref$vertical;
  return vertical ? verticalStyles : horizontalStyles;
});